export default {
  state: {
    mfaCallback: null,
    otpCallback: null,
    cancelMfaCallback: null,
    cancelOTPCallback: null,
    showMfaDialog: false,
    showOTPDialog: false,
    otpBusiness: null
  },
  mutations: {
    SET_MFA_CALLBACK: (state, callback) => {
      state.mfaCallback = callback
    },
    SET_SHOW_MFA_DIALOG: (state, show) => {
      state.showMfaDialog = show
    },
    SET_OTP_CALLBACK: (state, callback) => {
      state.otpCallback = callback
    },
    SET_SHOW_OTP_DIALOG: (state, show) => {
      state.showOTPDialog = show
    },
    SET_CANCEL_MFA_CALLBACK: (state, callback) => {
      state.cancelMfaCallback = callback
    },
    SET_CANCEL_OTP_CALLBACK: (state, callback) => {
      state.cancelOTPCallback = callback
    },
    SET_OTP_BUSINESS: (state, business) => {
      state.otpBusiness = business
    }
  },
  actions: {
    showMfaDialog({ commit }, callback) {
      commit('SET_MFA_CALLBACK', callback)
      commit('SET_SHOW_MFA_DIALOG', true)
    },
    hideMfaDialog({ commit, dispatch }, callback) {
      dispatch('executeMfaCancelCallback')
      commit('SET_SHOW_MFA_DIALOG', false)
      commit('SET_MFA_CALLBACK', null)
    },
    setCancelMfaCallback({ commit }, callback) {
      commit('SET_CANCEL_MFA_CALLBACK', callback)
    },
    executeMfaCallback({ state }, mfaCode) {
      if (state.mfaCallback) {
        state.mfaCallback(mfaCode)
      }
    },
    executeMfaCancelCallback({ state, commit }) {
      if (state.cancelMfaCallback) {
        state.cancelMfaCallback()
        commit('SET_CANCEL_MFA_CALLBACK', null)
      }
    },
    showOTPDialog({ commit }, {callback, business}) {
      commit('SET_OTP_CALLBACK', callback)
      commit('SET_OTP_BUSINESS', business)
      commit('SET_SHOW_OTP_DIALOG', true)
    },
    hideOTPDialog({ commit, dispatch }, callback) {
      dispatch('executeOTPCancelCallback')
      commit('SET_SHOW_OTP_DIALOG', false)
      commit('SET_OTP_CALLBACK', null)
      commit('SET_OTP_BUSINESS', null)
    },
    setCancelOTPCallback({ commit }, callback) {
      commit('SET_CANCEL_OTP_CALLBACK', callback)
    },
    executeOTPCallback({ state, commit }, otpCode) {
      if (state.otpCallback) {
        state.otpCallback(otpCode)
      }
    },
    executeOTPCancelCallback({ state, commit }) {
      if (state.cancelOTPCallback) {
        state.cancelOTPCallback()
        commit('SET_CANCEL_OTP_CALLBACK', null)
      }
    }
  }
}
